import { render, staticRenderFns } from "./DocumentPurchaseAnalysis.vue?vue&type=template&id=1026e3e7"
import script from "./DocumentPurchaseAnalysis.vue?vue&type=script&lang=js"
export * from "./DocumentPurchaseAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports